import { BitrixVue, reactive } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { VplRouter } from 'vpl.tas';
import { findGetParameter, setCookie, getCookie } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { CatalogCard } from 'vpl.tas';
import { showCatalogPreloader, hideCatalogPreloader  } from 'vpl.tas';
import { holdCatalogPreloader, releaseCatalogPreloader } from 'vpl.tas';

export const FavoritePage = {
    components: {
        ItemEditBtns,
        CatalogCard
    },
    props: {
        structKey: [String, Number]
    },
    updated(){
        this.items = this.struct[this.structKey].componentData.ITEMS;
        this.pagin = this.struct[this.structKey].componentData.PAGIN;
    },
    mounted(){
        this.items = this.struct[this.structKey].componentData.ITEMS;
        this.pagin = this.struct[this.structKey].componentData.PAGIN;
    },
    methods: {
        lazyLoad(link ,append = true){

            link = link.split('#')[0];
            let arRoute = link.split('?');
            let params = 'get_json=Y';
            if(arRoute[1]){
                params += '&' + arRoute[1];
            }

            holdCatalogPreloader();
            $.ajax({
                url: arRoute[0] + '?' + params,
                method: 'GET',
                complete: () => releaseCatalogPreloader(),
                success: (response) => {
                    response = JSON.parse(response);
                    if(append){
                        this.struct[this.structKey].componentData.ITEMS = [...this.items, ...response.struct[this.structKey].componentData.ITEMS];
                    }else{
                        this.struct[this.structKey].componentData.ITEMS = response.struct[this.structKey].componentData.ITEMS;
                    }
                    this.struct[this.structKey].componentData.PAGIN = response.struct[this.structKey].componentData.PAGIN;
                }
            });
        },
        clearFavorite(){
            $.ajax({
                url: '/ajax/favorite.php',
                method: 'POST',
                data: {'clear': 'Y'},
                success: () => {
                    this.struct[this.structKey].componentData.ITEMS = {};
                    this.favorite = {};
                }
            });
        }
    },
    computed: {
        ...mapState(vplSiteStore, ['SITE_TEMPLATE_PATH', 'templateData', 'struct', 'favorite']),
        sectionData(){
            return this.struct[this.structKey].componentData;
        }
    },
    template: `
<section class="section section--first">
    <div class="container">
        <div v-if="this.struct[this.structKey].componentData.ITEMS && Object.keys(this.struct[this.structKey].componentData.ITEMS).length" class="compare-nav__clear compare-nav__clear--fav">
            <a href="#" @click.prevent="clearFavorite()" class="compare-nav__clear-btn">
                <div class="compare-nav__clear-btn-icon">
                    <svg class="ico ico-basket ico-solo" width="20" height="19" aria-hidden="true"><use xlink:href="#ico-basket"></use></svg>
                </div>
                <div class="compare-nav__clear-text">
                    Очистить всё
                </div>
            </a>
        </div>

        <div class="fav-list js-catalog-list" v-if="this.sectionData.ITEMS && Object.keys(this.struct[this.structKey].componentData.ITEMS).length">

            <template v-for="item in this.sectionData.ITEMS">
                <CatalogCard :item="item"/>
            </template>

            <div class="content-nav" v-if="this.sectionData.PAGIN">
                <ul class="content-nav__list">
                    <template v-for="link in this.sectionData.PAGIN">
                        <li v-if="link.type==='left_arrow'" class="content-nav__list-item content-nav__list-item--prev">
                            <a :href="link.link" @click.prevent="lazyLoad(link.link, false)" data-skip="y">
                                <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                            </a>
                        </li>
                        <li v-if="link.type==='number'" :class="{active: link.selected}" class="content-nav__list-item"><a @click.prevent="lazyLoad(link.link, false)" data-skip="y" :href="link.selected ? '#' : link.link">{{ link.text }}</a></li>
                        <li v-if="link.type==='dots'" class="content-nav__list-item"><a @click.prevent="lazyLoad(link.link, false)" data-skip="y" :href="link.link">...</a></li>
                        <li v-if="link.type==='right_arrow'" class="content-nav__list-item content-nav__list-item--next">
                            <a :href="link.link" data-skip="y" @click.prevent="lazyLoad(link.link, false)">
                                <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                            </a>
                        </li>
                    </template>
                </ul>

                <template v-for="link in this.sectionData.PAGIN">
                    <a v-if="link.type==='showmore'" href="#" @click.prevent="lazyLoad(link.link)" class="btn btn--border">Показать ещё</a>
                </template>
            </div>
        </div>
        <div class="fav-list js-catalog-list" v-else>
            <p>Ваш список избранного пуст</p>
        </div>
    </div>
</section>
    `
}